export const environment = {
  production: false,
  apiUrl: 'https://api.pmi-fakture.dev.itcentar.rs',
};
